module.exports = __webpack_public_path__ + "static/q12_x-8720763ff4c685cb0a5daa770f0e3d3b.png";